import { FIELD as TABLE_SORT_FIELD } from './constants'
import { FIELD as TABLE_LINK_FIELD } from './RankingTable/RankingTable'

export const GA_CLICK_ACTION = {
  TABLE_SORT: 'TABLE_SORT',
  TABLE_LINK: 'TABLE_LINK',
  READ_MORE: 'READ_MORE',
  TAB: 'TAB'
}

export const GA_KEY = {
  TABLE_SORT_QUANTITY: 'TABLE_SORT_QUANTITY',
  TABLE_SORT_YESTERDAY_QUANTITY: 'TABLE_SORT_YESTERDAY_QUANTITY',
  TABLE_SORT_AMOUNT: 'TABLE_SORT_AMOUNT',
  TABLE_SORT_NOTIFY_QUANTITY: 'TABLE_SORT_NOTIFY_QUANTITY',
  TABLE_SORT_TAG_QUANTITY: 'TABLE_SORT_TAG_QUANTITY',
  TABLE_LINK_ITEM_PRICE: 'TABLE_LINK_ITEM_PRICE',
  TABLE_LINK_AVAILABLE_COUNT: 'TABLE_LINK_AVAILABLE_COUNT',
  READ_MORE: 'READ_MORE',
  TAB: 'TAB'
}

const GA_KEY_MAP = {
  [GA_KEY.TABLE_SORT_QUANTITY]: 'abandoned_ordergd',
  [GA_KEY.TABLE_SORT_YESTERDAY_QUANTITY]: 'abandoned_list_yesterday',
  [GA_KEY.TABLE_SORT_AMOUNT]: 'abandoned_orderamt',
  [GA_KEY.TABLE_SORT_NOTIFY_QUANTITY]: 'abandoned_ordergd',
  [GA_KEY.TABLE_SORT_TAG_QUANTITY]: 'abandoned_favcnt',
  [GA_KEY.TABLE_LINK_ITEM_PRICE]: 'abandoned_currentprice',
  [GA_KEY.TABLE_LINK_AVAILABLE_COUNT]: 'abandoned_availcnt',
  [GA_KEY.READ_MORE]: 'abandoned_moreitems',
  [GA_KEY.TAB]: 'customerinterest_tabs'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload, statsType } = action
  // remove 'customerInterest' prefix and convert first letter to lower case
  const i13nPrefix = statsType.replace('customerInterest', '').replace(/^./, str => str.toLowerCase())
  let key
  switch (type) {
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [TABLE_SORT_FIELD.QUANTITY]: GA_KEY.TABLE_SORT_QUANTITY,
        [TABLE_SORT_FIELD.YESTERDAY_QUANTITY]: GA_KEY.TABLE_SORT_YESTERDAY_QUANTITY,
        [TABLE_SORT_FIELD.AMOUNT]: GA_KEY.TABLE_SORT_AMOUNT,
        [TABLE_SORT_FIELD.NOTIFY_QUANTITY]: GA_KEY.TABLE_SORT_NOTIFY_QUANTITY,
        [TABLE_SORT_FIELD.TAG_QUANTITY]: GA_KEY.TABLE_SORT_TAG_QUANTITY
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_LINK: {
      const map = {
        [TABLE_LINK_FIELD.ITEM_PRICE]: GA_KEY.TABLE_LINK_ITEM_PRICE,
        [TABLE_LINK_FIELD.AVAILABLE_COUNT]: GA_KEY.TABLE_LINK_AVAILABLE_COUNT
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.READ_MORE:
      key = GA_KEY[type]
      break
    case GA_CLICK_ACTION.TAB:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key].replace('abandoned', i13nPrefix),
    ...customizeI13nModel
  }
  return i13nModel
}
